import { Method } from 'axios';

export const getErrorMessageTitle = (requestMethod: Method, url: string) => {
    let title = '';

    for (const path in titles) {
        if (url.includes(path)) {
            title = titles[path];
            break;
        }
    }

    if (!title) {
        return 'Request Failed';
    }

    const action = getIntendedAction(requestMethod);

    if (!action) {
        return 'Unknown action';
    }

    return `${title} ${action}`;
};

const titles: { [key: string]: string } = {
    ServiceEntry: 'Service Entry could not be',
    Vehicle: 'Vehicle(s) could not be',
};

const getIntendedAction = (requestMethod: Method) => {
    switch (requestMethod.toLowerCase()) {
        case 'get':
            return 'fetched';
        case 'post':
            return 'created';
        case 'put':
            return 'updated';
        case 'delete':
            return 'deleted';
        default:
            return '';
    }
};
